import { useMemo } from 'react'
import type { ActivityDetails } from '../../../typings'

export function useInitValues(currentActivity?: ActivityDetails) {
  return useMemo(
    () => ({ status: currentActivity?.status || 'Todo' }),
    [currentActivity],
  )
}
